import React, { useState, useEffect } from 'react';
import instance from '../../utils/axiosInstance';
import { Spin } from 'antd'; // Antd ka Spin loading ke liye
import toast, { Toaster } from 'react-hot-toast'; // Toast Notification Import

// Define the fields to be managed
const fields = [
  { label: "Single Digit", rateKey: "singleDigit", valueKey: "singleDigitValue" },
  { label: "Double Pana", rateKey: "doublePana", valueKey: "doublePanaValue" },
  { label: "Single Pana", rateKey: "singlePana", valueKey: "singlePanaValue" },
  { label: "Triple Pana", rateKey: "triplePana", valueKey: "triplePanaValue" },
];

const GameRates = () => {
  const [rates, setRates] = useState({});
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [isCreating, setIsCreating] = useState(false); // Add vs Update mode check karne ke liye

  // Function to fetch game rates.
  const fetchGameRates = async () => {
    try {
      setLoading(true);
      const response = await instance.get(`/api/starline/rates`);
      
      if (response.data) {
        // Remove unwanted fields.
        const { _id, __v, createdAt, updatedAt, ...filteredData } = response.data;
        setRates(filteredData);
        setIsCreating(false); // Data mil gaya, matlab Update mode
      }
    } catch (error) {
      // Agar 404 hai, iska matlab data nahi hai -> Create Mode ON
      if (error.response && error.response.status === 404) {
        console.log("No rates found, switching to Create mode.");
        setIsCreating(true);
        setRates({}); 
      } else {
        console.error('Error fetching game rates:', error);
        toast.error('Failed to fetch game rates!'); // Toast Error
      }
    } finally {
      setLoading(false);
    }
  };

  // Fetch game rates when the component mounts.
  useEffect(() => {
    fetchGameRates();
  }, []);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRates({ ...rates, [name]: value });
  };

  // Handle Update / Add logic
  const handleUpdate = async () => {
    setUpdating(true);
    try {
      let response;
      
      if (isCreating) {
        // --- ADD API CALL (POST) ---
        response = await instance.post(`/api/starline/rates`, rates);
        if (response.data) {
          toast.success('Game rates ADDED successfully!'); // Toast Success
          setIsCreating(false); // Ab data ban gaya hai, toh next time Update hoga
        }
      } else {
        // --- UPDATE API CALL (PATCH) ---
        const updatedRates = { ...rates };
        response = await instance.patch(`/api/starline/rates`, updatedRates);
        if (response.data) {
          toast.success('Game rates UPDATED successfully!'); // Toast Success
        }
      }

      // Automatically re-fetch updated rates.
      await fetchGameRates();

    } catch (error) {
      console.error('Error saving game rates:', error);
      const errorMsg = error.response?.data?.message || 'Failed to save game rates';
      toast.error(errorMsg); // Toast Error with backend message
    } finally {
      setUpdating(false);
    }
  };

  if (loading) {
    return (
      <div className="w-full h-screen flex justify-center items-center">
        <Spin size="large" />
        <p className="text-xl text-gray-600 ml-4">Loading...</p>
      </div>
    );
  }

  return (
    <div className="p-4 max-w-6xl mx-auto relative">
      {/* Toaster Component Zaroori Hai */}
      <Toaster position="top-right" reverseOrder={false} />

      <div className="bg-white p-6 shadow-md rounded-lg">
        <h2 className="text-2xl font-bold mb-4 text-left">
          {isCreating ? "Add Game Rates" : "Update Game Rates"}
        </h2>

        <div className="space-y-4">
          {fields.map((field) => (
            <div key={field.rateKey} className="grid grid-cols-2 gap-4 items-center">
              {/* Rate Input Column */}
              <div className="flex flex-col">
                <label className="font-bold text-gray-900 text-sm mb-1">
                  {field.label} (Rate)
                </label>
                <input
                  type="number"
                  name={field.rateKey}
                  value={rates[field.rateKey] || ""}
                  onChange={handleInputChange}
                  placeholder="Enter Rate"
                  className="border border-gray-300 rounded-md p-2 text-sm"
                />
              </div>
              {/* Value Input Column with Rupee Symbol */}
              <div className="flex flex-col">
                <label className="font-bold text-gray-900 text-sm mb-1">
                  {field.label} (Value)
                </label>
                <div className="flex items-center border border-gray-300 rounded-md">
                  <span className="px-2 text-lg">₹</span>
                  <input
                    type="number"
                    name={field.valueKey}
                    value={rates[field.valueKey] || ""}
                    onChange={handleInputChange}
                    placeholder="Enter Value"
                    className="p-2 text-sm flex-1 outline-none"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Update Button */}
        <button
          onClick={handleUpdate}
          disabled={updating}
          className="mt-6 bg-blue-500 text-white px-4 py-2 rounded w-full sm:w-auto flex justify-center items-center hover:bg-blue-600 transition"
        >
          {updating ? (
            <>
              <div className="animate-spin rounded-full h-5 w-5 border-t-4 border-white mr-2"></div>
              {isCreating ? "Saving..." : "Updating..."}
            </>
          ) : (
            isCreating ? "Save Rates" : "Update Rates"
          )}
        </button>
      </div>
    </div>
  );
};

export default GameRates;